/**
 * Tag Controller
 *
 * @package:  Betta
 * @version:  2.1
 *
 */

import angular from 'angular';

angular.module('flsControllers').controller('TagController', ['$scope', 'Tag', function($scope, Tag){
    // Set the Loading state
    $scope.loading = false;
    // Set the Tag Scope
    $scope.tagScoupe = null;
    // Set initial number of Comments
    $scope.tags = [];
    // What tags are available?
    $scope.available_tags = [];
    // Init the new form
    $scope.form = {};
    // Number of Tags visible
    $scope.length = 0;

    /**
     * Init the Controller with the Context Ref string
     *
     * @param  {string} context_ref
     * @return {void}
     */
    $scope.init = function(context_ref, scope = '') {
        // Set loading state to true
        $scope.loading = true;
        // Set Tag Scope
        $scope.tagScoupe = scope;
        // Compile the Context
        $scope.context_ref = context_ref
        // Load the tags in context
        $scope.loadTags();
    }

    /**
     * Load the tags
     *
     * @return {void}
     */
    $scope.loadTags = function(){
        var request = angular.extend({context_ref:$scope.context_ref, scope:$scope.tagScoupe})

        Tag.get(request, function(response){
            if(response){
                $scope.tags = response.data;
                $scope.length = $scope.tags.length;
                // Set loading state to false
                $scope.loading = false;
            } else {
                // Display error
                toastr.error('Something went wrong')
                // Set loading state to false
                $scope.loading = false;
            };
        });
    }

    /**
     * Load the tags
     *
     * @return {void}
     */
    $scope.listTags = function(){
        var request = angular.extend({context_ref:$scope.context_ref, scope:$scope.tagScoupe})

        Tag.create(request, function(response){
            if(response){
                $scope.available_tags = response.data;
                // Set loading state to false
                $scope.loading = false;
            } else {
                // Display error
                toastr.error('Something went wrong')
                // Set loading state to false
                $scope.loading = false;
            };
        });
    }

    /**
     * Attach a tag
     *
     * @param {} form
     */
    $scope.addTag = function(slug){
        // Merge Form
        var request = angular.extend({context_ref:$scope.context_ref}, {slug:slug});
        // Set loading state to false
        $scope.loading = true;
        // Send store call
        Tag.save(request, function(response){
            if(response){
                $scope.loadTags();
            } else {
                // Display error
                toastr.error('Something went wrong')
                // Set loading state to false
                $scope.loading = false;
            };
        });
    }

    // Remove the Resource
    $scope.deleteTag = function(slug){
        // Set loading state to true
        $scope.loading = true;
        // iterate through scope.tags to find the one with ID
        angular.forEach($scope.tags, function(tag, index) {
            if(slug === tag.slug) {
                // Merge Form
                var request = angular.extend({context_ref:$scope.context_ref, method:'_DELETE'}, {id:tag.id, slug:slug});
                // Send destroy call (via POST with additional field, '_method' = 'DELETE')
                Tag.delete(request, function(response){
                    // Upon success, remove the element from the $scope.tags
                    if(response){
                        // Load the tags in context
                        $scope.loadTags();
                    } else {
                        // Display error
                        toastr.error('Something went wrong')
                        // Set loading state to false
                        $scope.loading = false;
                    };
                });
            }
        });
    }
}]);
